var Theme = Theme || {};

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// update quick buy variant selection and price
function updateQuickBuyVariant(productId, input) {
    const form = input.closest('form');
    const priceElement = document.querySelector('.uprice' + productId);
    const variantSelect = form.querySelector('.quick-buy-variant-select');
    
    // Update selected states for labels
    // First, remove 'selected' class from all labels in the same option group
    const optionPosition = input.getAttribute('data-option-position');
    form.querySelectorAll(`.quick-buy-variant-input[data-option-position="${optionPosition}"]`).forEach(radio => {
        if (radio.nextElementSibling) {
            radio.nextElementSibling.classList.remove('selected');
        }
    });
    
    // Then add 'selected' class to the clicked label
    if (input.nextElementSibling) {
        input.nextElementSibling.classList.add('selected');
    }
    
    // Get selected options for variant matching and image updates
    const selectedOptions = {};
    
    // First, collect swatch selections (colors)
    form.querySelectorAll('.swatch-input__input:checked').forEach(swatch => {
        const position = swatch.getAttribute('data-option-position');
        const value = swatch.getAttribute('data-option-value');
        if (position && value) {
            selectedOptions[position] = value;
        }
    });
    
    // Then, collect variant input selections (sizes)
    form.querySelectorAll('.quick-buy-variant-input:checked').forEach(radio => {
        const position = radio.getAttribute('data-option-position');
        const value = radio.getAttribute('data-option-value');
        if (position && value) {
            selectedOptions[position] = value;
        }
    });
    

    
    // Update both the hidden variant selector AND the visible productSelect
    if (variantSelect) {
        // Find the matching variant in the hidden select
        const options = variantSelect.querySelectorAll('option');
        let matchedVariantId = null;
        
        options.forEach(option => {
            const option1 = option.getAttribute('data-option1');
            const option2 = option.getAttribute('data-option2');
            const option3 = option.getAttribute('data-option3');
            
            let isMatch = true;
            if (selectedOptions['1'] && option1 !== selectedOptions['1']) isMatch = false;
            if (selectedOptions['2'] && option2 !== selectedOptions['2']) isMatch = false;
            if (selectedOptions['3'] && option3 !== selectedOptions['3']) isMatch = false;
            
            if (isMatch) {
                option.selected = true;
                variantSelect.value = option.value;
                matchedVariantId = option.value;

            }
        });
        
        // Also update the visible productSelect if it exists
        if (matchedVariantId) {
            const productSelect = form.querySelector('.productSelect');
            if (productSelect) {
                productSelect.value = matchedVariantId;

            }
        }
    }
    
    // Update product image if variant has a different image
    updateProductImage(productId, selectedOptions);
    
    // Don't dispatch change event here to avoid infinite recursion
    // The change event is already handled by the event listener
}

// Function to update product card image based on selected variant
function updateProductImage(productId, selectedOptions) {
    // Find the product card container
    const productCard = document.querySelector(`[data-product-id="${productId}"]`) || 
                       document.querySelector(`.quick-buy-variant-input[id*="${productId}"]`)?.closest('.card');
    
    if (!productCard) return;
    
    // Find the hidden variant selector to get variant data
    const variantSelect = productCard.querySelector('.quick-buy-variant-select');
    if (!variantSelect) return;
    
    // Find the matching variant based on selected options
    const options = variantSelect.querySelectorAll('option');
    let matchingVariant = null;
    
    options.forEach(option => {
        const option1 = option.getAttribute('data-option1');
        const option2 = option.getAttribute('data-option2');
        const option3 = option.getAttribute('data-option3');
        
        let isMatch = true;
        if (selectedOptions['1'] && option1 !== selectedOptions['1']) isMatch = false;
        if (selectedOptions['2'] && option2 !== selectedOptions['2']) isMatch = false;
        if (selectedOptions['3'] && option3 !== selectedOptions['3']) isMatch = false;
        
        if (isMatch) {
            matchingVariant = option;
        }
    });
    
    if (!matchingVariant) return;
    
    const variantId = matchingVariant.value;
    
    // Look for variant images and find the one that matches the variant ID
    const variantImages = productCard.querySelectorAll(`[data-variant-id]`);
    
    if (variantImages.length > 0) {
        // Find the image that matches the selected variant ID
        let matchingImage = null;
        
        // Find the image that matches the variant ID
        variantImages.forEach((img) => {
            const imgVariantId = img.getAttribute('data-variant-id');
            
            if (imgVariantId === variantId) {
                matchingImage = img;
                return;
            }
        });
        
        if (matchingImage) {
            // Update the primary image
            const primaryImage = productCard.querySelector('.primary picture img');
            if (primaryImage) {
                // Use the image URLs directly - they should already be relative paths
                primaryImage.src = matchingImage.src;
                primaryImage.alt = matchingImage.alt || '';
                
                // Also update srcset to match the new image using the same format
                const newSrcset = matchingImage.src.replace('&width=1280', '&width=450') + ' 450w, ' +
                                 matchingImage.src.replace('&width=1280', '&width=550') + ' 550w, ' +
                                 matchingImage.src.replace('&width=1280', '&width=750') + ' 750w, ' +
                                 matchingImage.src.replace('&width=1280', '&width=950') + ' 950w, ' +
                                 matchingImage.src.replace('&width=1280', '&width=1100') + ' 1100w, ' +
                                 matchingImage.src + ' 1280w';
                primaryImage.srcset = newSrcset;
            }
        }
    }
}

// Function to update the card image
function updateCardImage(productCard, newImage) {
    const primaryImage = productCard.querySelector('.card-image .primary picture img');
    const secondaryImage = productCard.querySelector('.card-image .secondary picture img');
    
    if (primaryImage) {
        // Update primary image
        primaryImage.src = newImage.src;
        primaryImage.srcset = newImage.srcset || '';
        primaryImage.sizes = newImage.sizes || '';
        primaryImage.alt = newImage.alt || '';
    }
    
    // If there's a secondary image, we could also update it
    // This depends on your theme's hover image logic
}

// Initialize quick buy variant functionality with event delegation
function initializeQuickBuyVariants() {
    
    // Use event delegation for size/variant inputs (works for infinite scroll)
    document.addEventListener('change', function(event) {
        // Check if the changed element is a variant input
        if (event.target.matches('.quick-buy-variant-input')) {
            const input = event.target;
            const productId = input.id.split('-')[1];
    
            updateQuickBuyVariant(productId, input);
        }
    });
    
    // Initialize card swatch functionality
    initializeCardSwatches();
    
    // Set up observer for infinite scroll content
    setupInfiniteScrollObserver();
    

}


// Initialize card swatch functionality with event delegation
function initializeCardSwatches() {
    // Use event delegation to handle swatch clicks for both existing and dynamically loaded content
    document.addEventListener('change', function(event) {
        // Check if the changed element is a swatch input
        if (event.target.matches('.quick-buy-swatch-group .swatch-input__input')) {
            const input = event.target;
            
            const productId = input.closest('form')?.getAttribute('id')?.replace('card-form-', '') || 
                             input.closest('[data-product-id]')?.getAttribute('data-product-id');
            
            if (productId) {
                // Update the corresponding quick buy variant input
                updateQuickBuyVariantFromSwatch(productId, input);
            }
        }
    });
    
    // Initialize default selections for existing swatches
    initializeDefaultSwatchSelections();
}

// Function to initialize default swatch selections (can be called after new content loads)
function initializeDefaultSwatchSelections() {
    const swatchInputs = document.querySelectorAll('.quick-buy-swatch-group .swatch-input__input');
    
    // Group swatches by product
    const productGroups = {};
    swatchInputs.forEach((input, index) => {
        const productId = input.closest('form')?.getAttribute('id')?.replace('card-form-', '') || 
                         input.closest('[data-product-id]')?.getAttribute('data-product-id');
        
        if (productId) {
            if (!productGroups[productId]) {
                productGroups[productId] = [];
            }
            productGroups[productId].push(input);
        }
    });
        
    // For each product, ensure the first swatch is checked if none are checked
    Object.keys(productGroups).forEach(productId => {
        const productSwatches = productGroups[productId];
        const checkedSwatch = productSwatches.find(input => input.checked);
        
        if (!checkedSwatch && productSwatches.length > 0) {
            productSwatches[0].checked = true;
            
            // Also trigger variant selection for this product
            const form = productSwatches[0].closest('form');
            if (form) {
                updateQuickBuyVariantFromOptions(productId, form);
            }
        } else if (checkedSwatch) {
            
            // Still trigger variant selection to ensure everything is in sync
            const form = checkedSwatch.closest('form');
            if (form) {
                updateQuickBuyVariantFromOptions(productId, form);
            }
        }
    });
    

}

// Set up MutationObserver to handle infinite scroll content
function setupInfiniteScrollObserver() {
    // Target the main content container where new products get added
    const itemsContainer = document.querySelector('#InfiniScrollItemsContainer, .collection-products, .product-grid');
    
    if (!itemsContainer) {
        return;
    }
    
    // Create observer to watch for new nodes being added
    const observer = new MutationObserver(function(mutations) {
        let hasNewProducts = false;
        
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                // Check if any added nodes contain product cards
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        // Check if the node itself or its children contain swatch inputs
                        const hasSwatches = node.querySelector && (
                            node.querySelector('.quick-buy-swatch-group .swatch-input__input') ||
                            node.classList.contains('quick-buy-swatch-group')
                        );
                        
                        if (hasSwatches) {
                            hasNewProducts = true;
                        }
                    }
                });
            }
        });
        
        if (hasNewProducts) {
            // Small delay to ensure DOM is fully updated
            setTimeout(() => {
                initializeDefaultSwatchSelections();
            }, 100);
        }
    });
    
    // Start observing
    observer.observe(itemsContainer, {
        childList: true,
        subtree: true
    });
    

}



// Update card swatch selection state - no longer needed with proper form inputs

// Update variant when swatch is clicked
function updateQuickBuyVariantFromSwatch(productId, swatchInput) {
    
    // Find the product card
    const productCard = document.querySelector(`[data-product-id="${productId}"]`);
    if (!productCard) {
        return;
    }
    
    // Find the quick buy form (look for the card-form ID)
    const form = productCard.querySelector('form[id^="card-form-"]');
    if (!form) {
        return;
    }
        
    // FIRST: Capture currently selected size BEFORE making any changes
    let selectedSizeInput = form.querySelector('.quick-buy-variant-input:checked');
    let selectedSizeValue = selectedSizeInput ? selectedSizeInput.getAttribute('data-option-value') : null;
    let selectedSizePosition = selectedSizeInput ? selectedSizeInput.getAttribute('data-option-position') : null;
    
    // Get the swatch value
    const swatchValue = swatchInput.value;
    
    // Uncheck all swatches in the same group (colors only)
    form.querySelectorAll('.swatch-input__input[data-option-position="1"]').forEach(swatch => {
        swatch.checked = false;
    });
    
    // Check the clicked swatch
    swatchInput.checked = true;
    
    // Update size availability based on selected color FIRST
    updateSizeAvailability(form, swatchValue);
    
    // THEN: Restore the previously selected size if it's still available
    if (selectedSizeValue && selectedSizePosition) {
        // First, remove 'selected' class from ALL size labels in this position
        form.querySelectorAll(`[data-option-position="${selectedSizePosition}"]`).forEach(input => {
            const label = form.querySelector(`label[for="${input.id}"]`);
            if (label) {
                label.classList.remove('selected');
            }
        });
        
        const sizeInputToRestore = form.querySelector(`[data-option-value="${selectedSizeValue}"][data-option-position="${selectedSizePosition}"]`);
        if (sizeInputToRestore && !sizeInputToRestore.disabled) {
            sizeInputToRestore.checked = true;
            const label = form.querySelector(`label[for="${sizeInputToRestore.id}"]`);
            if (label) {
                label.classList.add('selected');
            }
        }
    }
    
    // Finally, update the variant selection
    updateQuickBuyVariantFromOptions(productId, form);
}

// Update size availability based on selected color
function updateSizeAvailability(form, selectedColor) {
    // Find all size options (position 2+)
    const sizeInputs = form.querySelectorAll('.quick-buy-variant-input[data-option-position="2"], .quick-buy-variant-input[data-option-position="3"]');
    
    sizeInputs.forEach(input => {
        const sizeValue = input.getAttribute('data-option-value');
        const label = form.querySelector(`label[for="${input.id}"]`);
        
        // Check if this size is available with the selected color
        const isAvailable = checkSizeAvailability(form, selectedColor, sizeValue);
        
        if (isAvailable) {
            // Enable the size option
            input.disabled = false;
            label.classList.remove('unavailable');
        } else {
            // Disable the size option
            input.disabled = true;
            label.classList.add('unavailable');
            
            // If this size was selected, unselect it
            if (input.checked) {
                input.checked = false;
                label.classList.remove('selected');
            }
        }
    });
}

// Check if a size is available with the selected color
function checkSizeAvailability(form, selectedColor, sizeValue) {
    // This would need to be implemented based on your variant data structure
    // For now, we'll assume all sizes are available to avoid breaking functionality
    // You can enhance this by checking against actual variant availability data
    return true;
}

// Helper function to format money (if not already available)
function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
    initializeQuickBuyVariants(); // initialize quick buy variants
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

// New function to update variant selection based on all selected options
function updateQuickBuyVariantFromOptions(productId, form) {
    const variantSelect = form.querySelector('.quick-buy-variant-select');
    if (!variantSelect) return;
    
    // Get all currently selected options
    const selectedOptions = {};
    
    // First, check swatch inputs (these are the color options)
    const checkedSwatches = form.querySelectorAll('.swatch-input__input:checked');
    checkedSwatches.forEach(swatch => {
        const position = swatch.getAttribute('data-option-position');
        const value = swatch.getAttribute('data-option-value');
        if (position && value) {
            selectedOptions[position] = value;
        }
    });
    
    // Then, check variant inputs (these are the size options)
    const checkedVariants = form.querySelectorAll('.quick-buy-variant-input:checked');
    checkedVariants.forEach(radio => {
        const position = radio.getAttribute('data-option-position');
        const value = radio.getAttribute('data-option-value');
        if (position && value) {
            selectedOptions[position] = value;
        }
    });
    
    
    // Find the matching variant in the hidden select
    const options = variantSelect.querySelectorAll('option');
    let variantFound = false;
    let matchedVariantId = null;
    
    options.forEach(option => {
        const option1 = option.getAttribute('data-option1');
        const option2 = option.getAttribute('data-option2');
        const option3 = option.getAttribute('data-option3');
        
        let isMatch = true;
        if (selectedOptions['1'] && option1 !== selectedOptions['1']) isMatch = false;
        if (selectedOptions['2'] && option2 !== selectedOptions['2']) isMatch = false;
        if (selectedOptions['3'] && option3 !== selectedOptions['3']) isMatch = false;
        
        if (isMatch) {
            option.selected = true;
            variantSelect.value = option.value;
            matchedVariantId = option.value;
            variantFound = true;
        }
    });
    
    // Also update the visible productSelect if it exists
    if (matchedVariantId) {
        const productSelect = form.querySelector('.productSelect');
        if (productSelect) {
            productSelect.value = matchedVariantId;
        }
    }
    

    
    // Update product image if variant has a different image
    // Pass the selected options instead of trying to find the variant again
    updateProductImage(productId, selectedOptions);
}